import { fetchExclusiveOfferLogic } from './fetchExclusiveOfferLogic';
import { fetchExclusiveOfferListLogic } from './fetchExclusiveOfferListLogic';

export const logic = [fetchExclusiveOfferLogic, fetchExclusiveOfferListLogic];
